<template>
<div>

<div ref="infinite-list" class="container-infinite-list" :key="list.length+new Date().getTime()">
  
  <slot v-for="i in maxItems" v-bind:item="list[i-1]"></slot>
  <spinner v-if="showLoadMore" class="load-more"/>
  
</div>
</div>
</template>

<script>
import { eventBus } from '../services/EventBus.js';
import Spinner from '../components/Spinner.vue';

export default {
  name: 'infinite-list',
  props:{
    list:{
      type:Array,
      default:()=>([])
    }
  },
  data:function(){
    return {
      ref:undefined,
      page:1,
      itemsPerpage:34,
      maxItems:0,
      showLoadMore:true,
    }
  },
  components:{
    Spinner,
  },
  methods:{
    renderPage(){
      
      //check items ahead:
      var count=(this.page*this.itemsPerpage);
     
      if(count>=this.list.length){
        // list is totally shown.
        this.maxItems=this.list.length;
        this.page=parseInt(Math.ceil(this.maxItems/this.itemsPerpage));
        this.showLoadMore=false;
      }else{
        // list in progress
        this.maxItems=count;
        this.showLoadMore=true;
      }
      
    },
    renderNextPage(){
        
       this.page++;
       this.renderPage();
      
    }
  },
  updated(){
    
    //this.renderPage();
  },
  beforeDestroy(){

    window.removeEventListener('resize',this.renderPage);
    eventBus.$off('SCROLL_BOTTOM_REACHED',this.renderNextPage);
    
  },
  mounted(){
   
    
    this.ref=this.$refs['infinite-list'];

    this.renderPage();

    window.addEventListener('resize',this.renderPage);
    
    // catch scroll event from ScrollPage
    eventBus.$on('SCROLL_BOTTOM_REACHED',this.renderNextPage);
  },
  watch:{
    list:function(){
      
      this.ref=this.$refs['infinite-list'];
      this.renderPage();

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.load-more{
  margin:10px 0px;
  font-weight:bold;
  text-align:center;
  position:relative;
}



</style>

